module.exports = __webpack_public_path__ + "static/integration-overlay-6297d95fc186f642e7d09b6c380da079.png";